import {
    strollersAddQuestionUrl,
    strollersAddReviewScoreUrl,
    strollersAddReviewUrl,
    strollersAllReviewsGalleryUrl,
    strollersAllReviewsPhotosUrl,
    strollersArticlesOfSectionUrl,
    strollersArticlesUrl,
    strollersBrandsUrl,
    strollersChartsUrl,
    strollersComparisonUrl,
    strollersDetailUrl,
    strollersDetailVariantUrl,
    strollersEditDescription,
    strollersEditPhotosUrl,
    strollersListUrl,
    strollersMergeUrl,
    strollersPhotoEditorUrl,
    strollersPhotoUrl,
    strollersPhotosGalleryUrl,
    strollersRenameUrl,
    strollersReviewPhotoUrl,
    strollersReviewsUrl,
    strollersSearchByTypeUrl,
    strollersSearchUrl,
    strollersUrl,
    strollersVariantPhotoUrl,
    strollersVariantPhotosGalleryUrl,
    strollersWikiUrl,
} from "@/mk2/apps/strollers/urls";
import { Route } from "@/mk2/containers/Application/Application";

export const routes: Route[] = [
    {
        app: "strollers",
        path: strollersUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/Home/HomePage" /* webpackChunkName: "strollers.Home" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/Home/HomePage"],
    },
    {
        app: "strollers",
        path: strollersBrandsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/Brands/BrandsPage" /* webpackChunkName: "strollers.Brands" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/Brands/BrandsPage"],
    },
    {
        app: "strollers",
        path: strollersSearchUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage" /* webpackChunkName: "strollers.StrollersSearch" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage"],
    },
    {
        app: "strollers",
        path: strollersMergeUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerMerge/StrollerMergePage" /* webpackChunkName: "strollers.StrollerMerge" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerMerge/StrollerMergePage"],
    },
    {
        app: "strollers",
        path: strollersSearchByTypeUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage" /* webpackChunkName: "strollers.StrollersSearch" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage"],
    },
    {
        app: "strollers",
        path: strollersComparisonUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparisonPage" /* webpackChunkName: "strollers.StrollersComparison" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparisonPage"],
    },
    {
        app: "strollers",
        path: strollersChartsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/Charts/ChartsPage" /* webpackChunkName: "strollers.Charts" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/Charts/ChartsPage"],
    },
    {
        app: "strollers",
        path: strollersListUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage" /* webpackChunkName: "strollers.BrandsStrollersList" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage"],
    },
    {
        app: "strollers",
        path: strollersAddReviewUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage" /* webpackChunkName: "strollers.StrollerAddReview" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage"],
    },
    {
        app: "strollers",
        path: strollersReviewPhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhotoPage" /* webpackChunkName: "strollers.StrollerReviewPhoto" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhotoPage"],
    },
    {
        app: "strollers",
        path: strollersAllReviewsGalleryUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerAllReviewsGallery/StrollerAllReviewsGalleryPage" /* webpackChunkName: "strollers.StrollerAllReviewsGallery" */
            );
        },
        modules: [
            "@/mk2/apps/strollers/containers/StrollerAllReviewsGallery/StrollerAllReviewsGalleryPage",
        ],
    },
    {
        app: "strollers",
        path: strollersAllReviewsPhotosUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotosPage" /* webpackChunkName: "strollers.StrollerAllReviewsPhotos" */
            );
        },
        modules: [
            "@/mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotosPage",
        ],
    },
    {
        app: "strollers",
        path: strollersAddReviewScoreUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage" /* webpackChunkName: "strollers.StrollerAddReview" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage"],
    },
    {
        app: "strollers",
        path: strollersReviewsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage" /* webpackChunkName: "strollers.StrollerReviews" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage"],
    },
    {
        app: "strollers",
        path: strollersAddQuestionUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage" /* webpackChunkName: "strollers.StrollerAddQuestion" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage"],
    },
    {
        app: "strollers",
        path: strollersVariantPhotosGalleryUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGalleryPage" /* webpackChunkName: "strollers.StrollerProductGalleryPage" */
            );
        },
        modules: [
            "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGalleryPage",
        ],
    },
    {
        app: "strollers",
        path: strollersPhotosGalleryUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGalleryPage" /* webpackChunkName: "strollers.StrollerProductGalleryPage" */
            );
        },
        modules: [
            "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGalleryPage",
        ],
    },
    {
        app: "strollers",
        path: strollersVariantPhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage" /* webpackChunkName: "strollers.StrollerProductPhotoPage" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage"],
    },
    {
        app: "strollers",
        path: strollersPhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage" /* webpackChunkName: "strollers.StrollerProductPhotoPage" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage"],
    },
    {
        app: "strollers",
        path: strollersWikiUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/WikiArticle/WikiArticlePage" /* webpackChunkName: "strollers.WikiArticle" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/WikiArticle/WikiArticlePage"],
    },
    {
        app: "strollers",
        path: strollersArticlesUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSectionsPage" /* webpackChunkName: "strollers.ArticlesOfSections" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSectionsPage"],
    },
    {
        app: "strollers",
        path: strollersArticlesOfSectionUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSectionsPage" /* webpackChunkName: "strollers.ArticlesOfSections" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSectionsPage"],
    },
    {
        app: "strollers",
        path: strollersRenameUrl,
        getPage: () => {
            return import("@/mk2/apps/strollers/containers/StrollerRename/StrollerRenamePage");
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerRename/StrollerRenamePage"],
    },
    {
        app: "strollers",
        path: strollersEditDescription,
        getPage: () => {
            return import("@/mk2/apps/strollers/containers/StrollerEditDescription/StrollerEditDescriptionPage");
        },
        modules: [
            "@/mk2/apps/strollers/containers/StrollerEditDescription/StrollerEditDescriptionPage",
        ],
    },
    {
        app: "strollers",
        path: strollersEditPhotosUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerEditPhotos/StrollerEditPhotosPage" /* webpackChunkName: "strollers.StrollerEditPhotos" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerEditPhotos/StrollerEditPhotosPage"],
    },
    {
        app: "strollers",
        path: strollersPhotoEditorUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollerPhotoEditor/StrollerPhotoEditorPage" /* webpackChunkName: "strollers.StrollerPhotoEditor" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollerPhotoEditor/StrollerPhotoEditorPage"],
    },

    // Keep StrollersDetailPage as last item
    {
        app: "strollers",
        path: strollersDetailVariantUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage" /* webpackChunkName: "strollers.StrollersDetail" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage"],
    },
    {
        app: "strollers",
        path: strollersDetailUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage" /* webpackChunkName: "strollers.StrollersDetail" */
            );
        },
        modules: ["@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage"],
    },
];
